export default {"src":"/_next/static/media/edit.aac9bd0e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};